import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

import './App.css'

import Home from './pages/Home'
import Bills from './pages/Bills'
import Bill from './pages/Bill'
import Questions from './pages/Questions'
import Question from './pages/Question'

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/questions" render={(props) => <Questions />}>
          <Questions />
        </Route>
        <Route exact path="/questions/:id" render={(props) => <Question />}>
          <Question />
        </Route>
        <Route exact path="/bills" render={(props) => <Bills />}>
          <Bills />
        </Route>
        <Route exact path="/bills/:id" render={(props) => <Bill />}>
          <Bill />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Router>
  )
}

export default App
